//@Actions
const { getPortfolioList } = require('./brokerCustomWalletGetPortfoliosList');
const { getStocksByType } = require('./brokerCustomWalletStocksByType');
const { getDefaultViewID } = require('actions/myWallet');

const getWalletData = (callback) => (dispatch, getState) => {
    const getPortfolios = dispatch(getPortfolioList());

    if (getPortfolios) {

        getPortfolios.then(() =>{
            const getDefaultView = dispatch(getDefaultViewID());

            if (getDefaultView) {
                getDefaultView.then(() => {
                    const isGeneral = getState().myWalletCharts.get('isGeneralViewSelected');
                    if (!isGeneral) {
                        const defaultViewId = getState().myWalletCharts.getIn(['defaultView','idDefaultView']);

                        dispatch(getStocksByType(defaultViewId));
                    }
                    else {
                        callback();
                    }
                }).catch(() => {
                    callback();
                });
            } else {
                callback();
            }
        }).catch(() => {
            callback()
        });
    }
    else {
        callback();
    }
};

module.exports = {
    getWalletData
}
